import { InjectedStyledComponent } from '../../shared/InjectedStyledComponent';
import Input from '@kurtosys/ksys-app-components/dist/components/base/Input';

export default InjectedStyledComponent(Input, 'searchBar', ['input']);
